import { useEffect, useState } from 'react';
import { Grid } from '@mui/material';
import TermsAndCondition from './TermsAndCondition';
import { appSettings } from '../settings';
import { useTranslation } from 'react-i18next';
import type { IBuildVersion } from '../../types/IComponentTypes';

function getVersion() {
  return fetch('../public/versioninfo.json', { cache: 'no-store' }).then((response) =>
    response.json()
  );
}

export const Footer = () => {
  const { t } = useTranslation();

  const [value, setValue] = useState<IBuildVersion>();

  useEffect(() => {
    getVersion().then((data) => {
      setValue(data);
    });
  }, []);

  const color: { [index: string]: string } = {
    DEV: 'bg-yellow',
    TEST: 'bg-orange',
    ACC: 'bg-green',
    PROD: 'bg-gray',
    'Test-Node2': 'bg-orange',
    'Test-Node1': 'bg-orange',
  };

  return (
    <Grid className={`footer root ${color[appSettings.Environment]}`}>
      <Grid className="env">
        <span>
          {t('footer.env')}: {appSettings.Environment}
        </span>
      </Grid>
      <Grid className="termsAndConditionStyle">
        <TermsAndCondition />
        &nbsp;&nbsp;
        <span>
          <b>{t('footer.release')}</b>:{value?.release} | <b>{t('footer.sprint')}</b>:
          {value?.sprint} | <b>{t('footer.build')}</b>:{value?.build} | <b>{t('footer.branch')}</b>:
          {value?.branch} | <b>{t('footer.date')}</b>: {value?.date}
        </span>
      </Grid>
    </Grid>
  );
};
